export default __webpack_public_path__ + "static/media/download.3cfcb9ce.svg";